import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setNav_Item } from "../redux/NavBarSlice";

const NULL_ROUTES = [
  "insights",
  "insight-blog",
  "contactus",
  "termsandconditions",
  "privacypolicy",
  "contactform",
  "admin",
  "cookies",
  "certifications",
  "totalcards",
];

const useActiveNavItem = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  // 🔑 IMPORTANT: read sidebar state
  const sidebarVisible = useSelector((state) => state.sidebarItem.visible);

  useEffect(() => {
    // 🔑 DO NOT override nav when sidebar is open
    if (sidebarVisible) return;

    const path = location.pathname;

    if (NULL_ROUTES.some((route) => path.includes(route))) {
      dispatch(setNav_Item(null));
    } else if (path.includes("careers")) {
      dispatch(setNav_Item("careers"));
    } else if (path.includes("solutions")) {
      dispatch(setNav_Item("solutions"));
    } else if (path.includes("services")) {
      dispatch(setNav_Item("services"));
    } else if (path.includes("industry")) {
      dispatch(setNav_Item("industries"));
    } else if (path.includes("products")) {
      dispatch(setNav_Item("products"));
    } else if (path.includes("aboutus")) {
      dispatch(setNav_Item("aboutus"));
    } else if (path.includes("agentforce") && !path.includes("products")) {
      dispatch(setNav_Item("agentforce"));
    } else if (path.includes("hrms")) {
      dispatch(setNav_Item("hrms"));
    } else {
      dispatch(setNav_Item("home"));
    }
  }, [location.pathname, sidebarVisible, dispatch]);
};

export default useActiveNavItem;
